import React, { Component } from 'react';
import { components } from 'common';
import { classSet } from '@umu/umu-dom';
import { IUserMedal } from '@umu/umu-types';
import { openWindow, unescapeHtml } from '@umu/umu-util';
const { If } = components;

import UserMedalIcon from './components/userMedalIcon';
import './index.scss';

export interface IProps {
    className?: string;
    name: string;
    userMedalInfo?: IUserMedal;
    showUserLevel?: number;
    userMedalWidth?: 20 | 30 | 16;
    href?: string;
    userLable?: string; // 用户标签
    labelSize?: 's' | 'm' | 'l'; // 用户标签大小
    clamp?: number; // 几行截断
}

export class UmuUserName extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const {
            name,
            href,
            showUserLevel,
            userMedalInfo,
            clamp = 1,
            className = '',
            userLable = '',
            labelSize = 'm',
            userMedalWidth = 20,
        } = this.props;
        const showMedal = !!showUserLevel && !!userMedalInfo && !!userMedalInfo.medal_type;
        const cursor = !!href ? 'cursor' : '';

        const goHome = () => {
            if (!href) {
                return;
            }
            openWindow(href, '_blank');
        };

        return (
            <div className={classSet('umu-user-name', cursor, className)} onClick={goHome}>
                <span className={`umu-user-name__content umu-text-clamp clamp-${clamp}`}>{unescapeHtml(name)}</span>
                <If condition={showMedal}>
                    <UserMedalIcon userMedalInfo={userMedalInfo} userMedalWidth={userMedalWidth} />
                </If>
                <If condition={!!userLable}>
                    <span className={`umu-user-name__label size--${labelSize}`}>{userLable}</span>
                </If>
            </div>
        );
    }
}
